<template>
  <div
    ref='scrollableContainer'
    class='scrollable'
    :class='{ "is-active": isActive }'
  >
    <slot />
  </div>
</template>

<script setup>
import { ref, defineExpose } from 'vue';

defineProps({
  isActive: { type: Boolean, required: true }
});

const scrollableContainer = ref(null);

const getScrollTop = () => (
  scrollableContainer.value ? scrollableContainer.value.scrollTop : 0
);

const scrollTo = ({ top = 0, behavior = 'auto' } = {}) => {
  if (scrollableContainer.value) {
    scrollableContainer.value.scrollTo({ top, behavior });
  }
};

const resetScroll = () => {
  scrollTo({ top: 0 });
};

defineExpose({
  scrollTo,
  getScrollTop,
  resetScroll,
  get scrollTop() {
    return getScrollTop();
  }
});
</script>

<style scoped lang='sass'>
@import 'app/packs/stylesheets/functions/rem'
@import 'app/packs/stylesheets/mixins/responsive'

.scrollable
  display: flex
  flex-direction: column
  flex-grow: 1
  position: relative

  &.is-active
    overflow-y: auto
</style>
